import { GratitudesApi } from 'api';
import { Api } from 'api/cabmun-content-public';
import { useCallback, useMemo, useState } from 'react';

export type CheckGratitudesAvailable = Api.GratitudesAvailable;

const yearsGlobal: {
  years: CheckGratitudesAvailable['years'];
  lastAddedTimestamp: CheckGratitudesAvailable['last_added_timestamp'];
  loaded: boolean;
} = {
  years: [],
  lastAddedTimestamp: null,
  loaded: false,
};

const useGratitudeCheck = () => {
  const [years, setYears] = useState<CheckGratitudesAvailable['years']>(yearsGlobal.years);
  const [lastAddedTimestamp, setLastAddedTimestamp] = useState<CheckGratitudesAvailable['last_added_timestamp']>(
    yearsGlobal.lastAddedTimestamp,
  );
  const fetch = useCallback(async () => {
    if (yearsGlobal.loaded) return;
    try {
      const result = await GratitudesApi.checkGratitudesAvailable();
      yearsGlobal.years = result.years;
      yearsGlobal.lastAddedTimestamp = result.last_added_timestamp;
    } catch (e) {
      yearsGlobal.years = [];
    }

    yearsGlobal.loaded = true;
    setYears(yearsGlobal.years);
    setLastAddedTimestamp(yearsGlobal.lastAddedTimestamp);
  }, [setYears]);

  return useMemo(() => ({ years, lastAddedTimestamp, fetch, loaded: yearsGlobal.loaded }), [years]);
};

export default useGratitudeCheck;
